import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { fetchAllProductStyles } from 'actions/productdetail/sharing';
import { trackError } from 'helpers/ErrorUtils';
import type { AppDispatch } from 'entrypoints/bootstrapOnClient';

const useFetchAllProductStyles = (productId: string) => {
  const dispatch: AppDispatch = useDispatch();

  useEffect(() => {
    const fetchStyles = async () => {
      try {
        await dispatch(fetchAllProductStyles(productId));
      } catch (error) {
        trackError('Error fetching customer auth details:', 'ERROR');
      }
    };

    fetchStyles();
  }, [fetchAllProductStyles, productId]);
};

export default useFetchAllProductStyles;
